import { Pipe, PipeTransform } from '@angular/core';
import { AgilityRiskDateTimeService } from '../providers/agility-risk-datetime.service';

@Pipe({
  name: 'agilityDatetime'
})
export class AgilityDatetimePipe implements PipeTransform {
  constructor(private datetimeService: AgilityRiskDateTimeService) {
  }

  transform(value: Date, datetimeFormat?: string): unknown {
    return this.datetimeService.formatDateTime(value, datetimeFormat);
  }
}
